'use client';

var propTypes = { exports: {} };
export {
  propTypes as __module
};
